import React from 'react'

interface GalleryGridProps {
  imagesPerRow: number
  children: React.ReactNode
}

const GalleryGrid: React.FC<GalleryGridProps> = ({ imagesPerRow, children }) => {
  return (
    <div
      className="w-100"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${imagesPerRow}, minmax(0, 1fr))`,
        gap: '1rem',
      }}
    >
      {children}
    </div>
  )
}

export default GalleryGrid
